import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const feedbackSchema = new schema.Entity(
  'feedbacks',
  {},
  {
    idAttribute: 'id',
  }
)
export const feedbackCategorySchema = new schema.Entity(
  'feedback_categories',
  {},
  {
    idAttribute: 'id',
  }
)


//     Route::post('feedbacks/feedback/create', 'FeedbackController@createFeedback');
export const feedback_createFeedback_Api = {
  backend: `Route::post('feedbacks/feedback/create', 'FeedbackController@createFeedback');`,
  root: API_ROOT_URL,
  path: '/feedbacks/feedback/create',
  method: 'POST',
  paramsFields: [],
  schema: feedbackSchema,
  transform: createTransform(feedbackSchema, 'data'),
}
//     Route::post('feedbacks/feedback/{id}/update', 'FeedbackController@updateFeedback');
export const feedback_updateFeedback_Api = {
  backend: `Route::post('feedbacks/feedback/{id}/update', 'FeedbackController@updateFeedback');`,
  root: API_ROOT_URL,
  path: '/feedbacks/feedback/:id/update',
  method: 'POST',
  paramsFields: [],
  schema: feedbackSchema,
  transform: createTransform(feedbackSchema, 'data'),
}
//     Route::post('feedbacks/feedback/{id}/delete', 'FeedbackController@deleteFeedback');
export const feedback_deleteFeedback_Api = {
  backend: `Route::post('feedbacks/feedback/{id}/delete', 'FeedbackController@deleteFeedback');`,
  root: API_ROOT_URL,
  path: '/feedbacks/feedback/:id/delete',
  method: 'POST',
  paramsFields: [],
  schema: feedbackSchema,
  transform: createTransform(feedbackSchema, 'data'),
}
//     Route::post('feedbacks/feedback/{id}/get', 'FeedbackController@getById');
export const feedback_getById_Api = {
  backend: `Route::post('feedbacks/feedback/{id}/get', 'FeedbackController@getById');`,
  root: API_ROOT_URL,
  path: '/feedbacks/feedback/:id/get',
  method: 'GET',
  schema: feedbackSchema,
  transform: createTransform(feedbackSchema, 'data'),
}
//     Route::get('feedbacks/feedback/gets', 'FeedbackController@getFeedbacks');
export const feedback_getFeedbacks_Api = {
  backend: `Route::get('feedbacks/feedback/gets', 'FeedbackController@getFeedbacks');`,
  root: API_ROOT_URL,
  path: '/feedbacks/feedback/gets',
  method: 'GET',
  fields: ['sort_by', 'keyword', 'status', 'feedback_category_id'],
  paramsFields: ['sort_by', 'keyword', 'status', 'feedback_category_id'],
  schema: feedbackSchema,
  transform: createListTransform(feedbackSchema),
}
// Route::get('feedbacks/feedback/get-closed-items', 'FeedbackController@getClosedFeedback');
export const feedback_getClosedFeedback_Api = {
  backend: `oute::get('feedbacks/feedback/get-closed-items', 'FeedbackController@getClosedFeedback');`,
  root: API_ROOT_URL,
  path: '/feedbacks/feedback/get-closed-items',
  method: 'GET',
  fields: ['sort_by', 'keyword', 'status', 'feedback_category_id'],
  paramsFields: ['sort_by', 'keyword', 'status', 'feedback_category_id'],
  schema: feedbackSchema,
  transform: createListTransform(feedbackSchema),
}
//     Route::get('feedbacks/feedback-category/gets', 'FeedbackController@getFeedbackCategories');
export const feedback_getFeedbackCategories_Api = {
  backend: `Route::get('feedbacks/feedback-category/gets', 'FeedbackController@getFeedbackCategories');`,
  root: API_ROOT_URL,
  path: '/feedbacks/feedback-category/gets',
  method: 'GET',
  fields: ['sort_by', 'keyword'],
  paramsFields: ['sort_by', 'keyword'],
  schema: feedbackCategorySchema,
  transform: createListTransform(feedbackCategorySchema),
}



